
import { Component, Vue } from 'nuxt-property-decorator'
import meta from '@/helpers/meta'

@Component
export default class LavoraConNoiPage extends Vue {
  public head() {
    return meta(
      'Privacy policy',
      'Informativa per trattamento di dati personali per gli utilizzatori del presente sito web e cookie policy sito web',
      this.$config.siteUrl + 'img/logo.png',
      this.$config.siteUrl + 'privacy-policy'
    )
  }
}
